<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
            @ok="moveUnit"
        >
            <template #modal-title>
                <div class="d-flex w-100 align-items-center">
                    Move Week
                </div>
            </template>

            <b-alert show variant="warning" class="mb-3">
                Once moved, the full publication needs to be imported to reflect the change.
            </b-alert>

            <b-form-group
                label="Unit"
                label-for="unit"
            >
                <b-form-select v-model="new_unit_group_id">
                    <b-form-select-option :value="null">Select a unit</b-form-select-option>
                    <b-form-select-option
                        v-for="(unit_group, index) in sorted_unit_groups"
                        :key="index"
                        :value="unit_group.id"
                    >
                        Unit {{unit_group.order_number}} - {{unit_group.title || 'no title'}}
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
                <b-button variant="secondary" @click="moveUnit">
                    <font-awesome-icon :icon="['fad', 'level-up']" /> Move Week
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        new_unit_group_id: null
    }),
    props: [
        'value',
        'publication_id',
        'unit_group',
        'unit'
    ],
    computed: {
        ...mapState({
            unit_groups: state => state.unit_groups.unit_groups,
        }),
        modal_id () {
            let modal_id = null

            if (this.unit.id) {
                modal_id = 'move-unit-modal' + this.unit.id
            }

            return modal_id
        },
        sorted_unit_groups() {
            let groups = []
            _.each(this.unit_groups, publication => {
                _.each(publication.unit_groups, unit_group => {
                    if (unit_group.id !== this.unit_group.id) {
                        groups.push(unit_group)
                    }
                })
            })
            return groups
        }
    },
    methods: {
        moveUnit () {
            if (this.new_unit_group_id !== this.unit_group.id) {
                this.axios.post('/api/units/move', {
                    unit_id: this.unit.id,
                    old_unit_group_id: this.unit_group.id,
                    new_unit_group_id: this.new_unit_group_id
                })
                .then(() => {
                    this.$store.dispatch('getUnitGroups', this.publication_id)
                    .then(() => {
                        this.hide()
                    })
                })
            } else {
                this.hide()
            }
        },
        cancel (event) {
            event.preventDefault()
            
            this.hide()
        },
        hide() {
            this.$emit('hide')
        },
        hidden () {
            this.new_unit_group_id = null

            this.$emit('hide')
        }
    }
}
</script>
